import { render, staticRenderFns } from "./DefaultDeadlineForm.vue?vue&type=template&id=0e2184f6&scoped=true"
import script from "./DefaultDeadlineForm.vue?vue&type=script&lang=js"
export * from "./DefaultDeadlineForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e2184f6",
  null
  
)

export default component.exports